import { createFileRoute } from '@tanstack/react-router';

import { CodebaseTabFlagGate } from '@/components/CodebaseView/CodebaseTabFlagGate';
import { FEATURE_FLAGS } from '@/constants/featureFlags';

// The Autodocs tab is gated behind the org-level AUTODOCS_UI flag (default-off → hidden).
// With the flag off, every page under it lands on the Settings tab.
export const Route = createFileRoute('/$organizationName/cb/$codebaseId/autodocs')({
  component: GatedCodebaseAutodocsLayout,
});

function GatedCodebaseAutodocsLayout() {
  return <CodebaseTabFlagGate flag={FEATURE_FLAGS.AUTODOCS_UI} />;
}
